"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxArrayValue = exports.getMaxValue = exports.tryParseInt = void 0;

var tryParseInt = function tryParseInt(str) {
  // detect typeof the incoming str value - it might not be a str, in fact it's probably already a number
  var defaultValue = 0;
  var retValue = defaultValue;

  if (str !== null) {
    // eslint-disable-next-line default-case
    switch (typeof str) {
      case 'string':
        if (str.length > 0) {
          if (!isNaN(str)) {
            retValue = parseFloat(str);
          }
        }

        break;

      case 'number':
        retValue = str;
        break;
    }
  }

  return retValue;
};

exports.tryParseInt = tryParseInt;

var getMaxValue = function getMaxValue(records, key) {
  return Object.values(records).reduce(function (maxIndex, p) {
    return Math.max(maxIndex, tryParseInt(p[key]));
  }, tryParseInt(records[0][key]));
};

exports.getMaxValue = getMaxValue;

var getMaxArrayValue = function getMaxArrayValue(records, key) {
  return records.reduce(function (maxIndex, p) {
    return Math.max(maxIndex, tryParseInt(p[key]));
  }, records[0][key]);
};

exports.getMaxArrayValue = getMaxArrayValue;